import React from "react";
import EntityRanking from "../EntityRanking";
import { PLATFORMS } from "../catalog";
import { ExternalLink } from "lucide-react";

const host = (url) => { try { return new URL(url).host; } catch (e) { return url; } };

export default function Platforms() {
  return (
    <EntityRanking title="Plataformas" meta={`${PLATFORMS.length} plataformas no catálogo, ordenadas por volume de eventos.`}
      field="platform" items={PLATFORMS} nameHeader="Plataforma" testid="platforms"
      renderName={(p) => (
        <div className="flex items-center gap-2.5 min-w-0">
          <span className="w-1 h-6 rounded-full shrink-0" style={{ background: p.color }} aria-hidden="true" />
          <div className="min-w-0">
            <p className="font-medium">{p.label}</p>
            <a href={p.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[12px] text-[var(--muted2)] hover:text-[var(--accent-ink)]">
              {host(p.link)} <ExternalLink size={11} />
            </a>
          </div>
        </div>
      )} />
  );
}
